import {
    ComponentConfig,
    LayoutTypes,
    ComponentType,
    FlexDirection,
    InputType,
} from "../services/types/ComponentTypes";

export const screen_176_gate_pass_issue: any[] = [
  {
    "componentType": "screenGroup",
    "title": "Gate Pass Issue",
    "style": {},
    "childComponents": [
      {
        "componentType": "form",
        "Name": "gate_pass_issue",
        "columnNumber": "m1 t1 w1",
        "TableName": "gate_pass_issue",
        "DisplayName": "Gate Pass",
        "formActions": [
          {
            "name": "lock",
            "type": "lock",
            "icon": "lock",
            "onPressAction": "unlock"
          },
          {
            "name": "print",
            "type": "pdf",
            "icon": "print",
            "onPressAction": "pdf",
            "settings": "gate_pass_issue_print"
          }
        ],
        "Workflow": "service",
        "style": {
          "backgroundColor": "#ffffff",
          "direction": "column",
          "padding": 10
        },
        "SubmitActions": [
          {
            "Action": "Navigate",
            "Navigate": "modulev1/vehicleinsummary"
          }
        ],
        "Fields": [
          {
            "componentType": "group",
            "Label": "",
            "BindValue": "cont_Action",
            "style": {
              "direction": "row",
              "padding": 0,
              "margin": 0,
              "marginBottom": 8
            }
          },
          {
            "componentType": "fieldGroup",
            "Label": "Gate Pass Details",
            "BindValue": "con_gate_pass_details",
            "style": {
              "direction": "column"
            },
            "childComponents": [
              {
                "IncludeLabel": true,
                "Label": "Gate Pass Issue Number",
                "PlaceHolder": "Will be auto generated (System)",
                "IsMandatory": false,
                "BindValue": "txt_gate_pass_number",
                "Json_Attribute": "gate_pass_no",
                "componentType": "textField",
                "showInSummary": false,
                "AutoPopulate": true,
                "IsReadOnly": true,
                "AutoPopulate_format": "GP_[******]",
                "IsVerticalView": true,
                "inputType": "text"
              },
              {
                "IncludeLabel": true,
                "Label": "Job No.",
                "PlaceHolder": "",
                "IsMandatory": false,
                "BindValue": "parentid",
                "Json_Attribute": "parent_id",
                "componentType": "searchableDropdown",
                "showInSummary": false,
                "IsReadOnly": true,
                "AutoSelect": "parentid",
                "LookupName": "gate_pass_jobcard",
                "IsVerticalView": true
              },
              {
                "IncludeLabel": true,
                "Label": "Status",
                "PlaceHolder": "",
                "IsMandatory": true,
                "BindValue": "gate_pass_status",
                "Json_Attribute": "gate_pass_status",
                "componentType": "selectDropdown",
                "showInSummary": false,
                "LookupName": "Create Gate Pass",
                "IsVerticalView": true,
                "options": [
                  {
                    "label": "Gate Pass Issued",
                    "value": "Gate Pass Issued"
                  }
                ]
              },
              {
                "Label": "",
                "BindValue": "gate_pass_report",
                "componentType": "report",
                "IncludeLabel": true,
                "Settings": "GatePassDetails",
                "Parent_Field": "parentid"
              },
              {
                "IncludeLabel": true,
                "Label": "Receiver Name",
                "PlaceHolder": "Enter receiver name",
                "IsMandatory": true,
                "BindValue": "txt_receiver_name",
                "Json_Attribute": "receiver_name",
                "componentType": "textField",
                "showInSummary": false,
                "IsVerticalView": true,
                "inputType": "text"
              },
              {
                "IncludeLabel": true,
                "Label": "Receiver Mobile Number",
                "PlaceHolder": "Enter mobile number",
                "IsMandatory": true,
                "BindValue": "txt_receiver_mobile",
                "Json_Attribute": "receiver_mobile",
                "componentType": "textField",
                "showInSummary": false,
                "IsVerticalView": true,
                "inputType": "phone"
              },
              {
                "IncludeLabel": true,
                "Label": "Date Out / Time",
                "PlaceHolder": "",
                "IsMandatory": true,
                "BindValue": "date_out_time",
                "Json_Attribute": "out_time",
                "componentType": "datetimeField",
                "showInSummary": false,
                "IsVerticalView": true,
                "DefaultToday": true
              },
              {
                "IncludeLabel": true,
                "Label": "KM Out",
                "PlaceHolder": "Enter KM Out",
                "IsMandatory": true,
                "BindValue": "txt_km_out",
                "Json_Attribute": "km_out",
                "componentType": "textField",
                "showInSummary": false,
                "IsVerticalView": true,
                "inputType": "number"
              },
              {
                "IncludeLabel": true,
                "Label": "Remarks",
                "PlaceHolder": "Enter remarks",
                "IsMandatory": false,
                "BindValue": "txt_remarks",
                "Json_Attribute": "remarks",
                "componentType": "textArea",
                "showInSummary": false,
                "IsVerticalView": true,
                "rows": 3
              }
            ]
          }
        ]
      },
      {
        "componentType": "button",
        "name": "Submit",
        "Label": "Submit",
        "BindValue": "btn_submit",
        "onPressAction": "save",
        "ScreenId": "176",
        "next_action": "Create Gate Pass",
        "next_state": "Gate Pass Issued",
        "ActionType": "Add"
      }
    ]
  }
];
